import {FC, useEffect} from 'react';
import {Box} from '@mui/material';
import AuctionHeader from '../components/AuctionHeader';
import AuctionItemsList from '../components/AuctionItemsList';
import {allItemsStyle} from './AllItems.styles';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getAuctionCategories, getAuctionCategoriesSelector} from '@/store/organization-auction';
import {getCurrentEventSelector} from '@/store/organization-event';
import {useAuctionTimer} from '@/utils/hooks';
import {userAPI} from '@/core/api';

const AllItems: FC = () => {
	const dispatch = useAppDispatch();
	const categories = useAppSelector(getAuctionCategoriesSelector);
	const event = useAppSelector(getCurrentEventSelector);

	const {hasEnded} = useAuctionTimer(event?.endAuctionData);

	useEffect(() => {
		const getCategoryData = async () => {
			await dispatch(getAuctionCategories(userAPI)).unwrap();
		};

		getCategoryData();
	}, []);

	return (
		<Box sx={allItemsStyle.wrapper}>
			<AuctionHeader />
			<AuctionItemsList categories={categories ?? []} auctionType="AllItems" hasEnded={hasEnded} key="AllItems" />
		</Box>
	);
};

export default AllItems;
